import React from 'react'
import 'animate.css'

export default function Bold() {
  return (
    <div className="mt-14">
      <div class="animate__animated animate__bounceIn">
        <div className='text-white max-[1140px]:text-6xl max-[1140px]:leading-normal max-[1300px]:leading-snug max-[992px]:text-5xl max-[992px]:leading-normal max-[800px]:text-4xl max-[800px]:leading-relaxed max-[634px]:leading-tight max-[455px]:text-3xl text-7xl leading-tight font-georama'>
  Hi There, I'm Saurav Kumar, 
  <span className='text-[#70F1A2]'>{"{FullStackDev}"}</span> &amp; 
  <span className='text-[#4E38D6]'> {"{MobileDev}"}</span>
</div>
</div>
    </div>
  )
}
